import {useMutation} from "@tanstack/react-query";
import {FileWithPath} from "@mantine/dropzone";
import axios, {AxiosError} from "axios";

export function useFileUpload() {
    return useMutation({
        mutationFn: async (files: FileWithPath[]) => {
            if (files.length === 0) {
                // This is for the "try it out" in the demo page
                await new Promise(resolve => setTimeout(resolve, 3000));
                return {
                    url: "/cgrdemograph.png"
                }
            }

            // Create a new FormData object
            const formData = new FormData();
            // Append each file to the FormData object
            files.forEach(file => formData.append('file', file));

            // Make a POST request using Axios to FastAPI server
            try {
                const response = await axios.post('https://lagg-docs.onrender.com/file_to_image', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data' // Set the content type to multipart/form-data
                    },
                    responseType: 'arraybuffer',// This turns data into an array. Console will return a bunch of special characters without it.
                    // remove responseType: 'arraybuffer' and the comma on line 60 then run it to see the special characters
                    withCredentials: false
                });
                console.log(response);
                // Handle response from the server
                console.log('Server response:', response.data);

                // Handle success, assuming response.data contains the ArrayBuffer
                const responseData = response.data;


                // Convert the ArrayBuffer to a Blob
                const blob = new Blob([responseData], {type: 'image/png'});

                // Create a DOMString representing the blob and append it to an <img> element
                return {
                    url: URL.createObjectURL(blob)
                };
            } catch (error: unknown) {
                if (error instanceof AxiosError && error.response) {
                    const decoder = new TextDecoder();
                    const arrayBuffer = error.response.data;
                    if (arrayBuffer instanceof ArrayBuffer) {
                        const text = decoder.decode(arrayBuffer);
                        const json = JSON.parse(text);
                        const exceptions = json.exception;
                        if (Array.isArray(exceptions) && exceptions[0]) {
                            throw new Error(exceptions[0]);
                        }
                    }
                }
                console.error(error);
                throw new Error("Oops! Something went wrong");
            }
        }
    });
}
